module.exports = __webpack_public_path__ + "img/PL08457.121ec6e8.png";